import { EVENT_TYPE, LANGUAGE } from "@utils/constants";
import {
  getParticipationPlatformAndLink,
  isCommunityAdmin,
  isEventEnded,
  isEventStarted,
  viewLocation,
} from "./helpers";

const getButtonType = (data, userContext) => {
  const isEnded = isEventEnded(data.end);
  const isStarted = isEventStarted(data.start);
  const eventType = data.eventTypeID;
  const isAdmin = isCommunityAdmin(
    data.viewerRole,
    data.uid,
    userContext.user.uid
  );
  //console.log("button data", { data, userContext });
  // console.log({ isEnded, isAdmin, isStarted });

  /*  
  If the user viewing the event is a founder or admin of this community
  */
 
  // if (isAdmin) {
  //   if (data.realParticipantNo > 0) return 3; // View Registrations

  //   return 4; // No Registrations yet
  // }

  if (data.end && isEnded) return 2;

  if (
    eventType === EVENT_TYPE.DONATION_CAMPAIGN ||
    eventType === EVENT_TYPE.PUJA
  ) {
    return 1;
  }
  if (eventType === EVENT_TYPE.LIVE && !data.CommunityEventRegistrationStatus) {
    return 8;
  }

  if (isStarted) {
    if (!data.isOnline && data.address) return 5; // View Event Destination

    /* event is online */
    const { participationlink: link } = getParticipationPlatformAndLink(data);

    if (link) return 6;

    return 0; // event started but no-address or link so hide button
  }

  /* ---------------- event has not started ------------------- */

  if (data.isRegistered) return 7;

  return 1;
};

export const getButtonDetails = ({ data, functions, userContext, lang }) => {
  //console.log("getButtonDetails", { data, functions, userContext });
  const btnType = getButtonType(data, userContext);
  const obj = {
    text: lang==LANGUAGE.ENGLISH?"Select Puja":"पूजा बुक करें",
    onClickHandler: null,
    hidden: false,
    type: btnType,
  };

  switch (btnType) {
    case 0:
      obj.hidden = true;
      break;

    case 1:
      obj.onClickHandler = functions.goToRegister;
      break;

    case 2:
      obj.text = "This kriya is completed";
      break;

    case 3:
      obj.text = "View Registrations";
      obj.onClickHandler = functions.openRegistrationModal;
      break;

    case 4:
      obj.text = "No registrations yet";
      break;

    case 5:
      obj.text = "View Event Destination";
      obj.onClickHandler = () => {
        viewLocation(data?.address);
      };
      break;

    case 6:
      obj.text = "Join";
      obj.onClickHandler = () => {
        const { participationlink: link } =
          getParticipationPlatformAndLink(data);
        window.open(link, "_blank");
      };
      break;

    case 7:
      // timer
      obj.text = "";
      break;
    case 8:
      obj.text = "Register Now";
      obj.onClickHandler = functions.goToRegister;
      break;
  }

  return obj;
};
